import { ProposalOrder } from './proposalOrder';

export class Track {
  id: number;
  channel: string;
  sessionId: number;
  proposals: ProposalOrder[];
  documentation: string;
  talkLink: string;
}
